import accessesIcon from '../assets/assesses/accesses.svg'
import truckIcon from '../assets/equipment/truck.svg'
import diplomaIcon from '../assets/sidemenu/diploma-active.svg'
import boxIcon from '../assets/sidemenu/box-active.svg'
import productionIcon from '../assets/home/production.svg'
import localIcon from '../assets/sidemenu/local-active.svg'
import clipboardIcon from '../assets/sidemenu/clipboard-active.svg'
import steelIcon from '../assets/home/steel.svg'
import resourceIcon from '../assets/home/resource.svg'
import serviceIcon from '../assets/home/service.svg'
import hangerIcon from '../assets/home/hanger.svg'
import companiesIcon from '../assets/home/companies.svg'
import vendasAcoIcon from '../../src/assets/home/orders.svg'
import collectionsIcon from '../assets/home/shirt.svg'
import financialIcon from '../assets/home/receipt.svg'
import fiscalIcon from '../assets/certificates/AddCertificate/invoice.svg'
import purchaseIcon from '../assets/home/purchase.svg'
import attachmentsIcon from '../assets/home/attachments.svg'
import { hasPermission, normalizePermissions } from '../utils/permissions'

export interface ModuleConfig {
  name: string
  path: string
  image: string
  section: string
  permission: string
  dependencies?: string[]
}

export const industrialModules: ModuleConfig[] = [
  {
    name: 'Desenvolvimento de Produto',
    path: 'product-final',
    image: steelIcon,
    section: 'Aplicações',
    permission: 'products'
  },
  {
    name: 'Qualidade',
    path: 'certificates',
    image: diplomaIcon,
    section: 'Aplicações',
    permission: 'certificates',
    dependencies: ['stock']
  },
  {
    name: 'Estoque',
    path: 'stock',
    image: boxIcon,
    section: 'Aplicações',
    permission: 'stock'
  },
  {
    name: 'Produção',
    path: 'production',
    image: productionIcon,
    section: 'Aplicações',
    permission: 'production',
    dependencies: ['stock', 'orders']
  },
  {
    name: 'Compras',
    path: 'purchase',
    image: purchaseIcon,
    section: 'Aplicações',
    permission: 'purchase',
  },
  {
    name: 'Financeiro',
    path: 'financial/entry',
    image: financialIcon,
    section: 'Aplicações',
    permission: 'financial'
  },
  {
    name: 'Vendas Aço',
    path: 'steel',
    image: vendasAcoIcon,
    section: 'Aplicações',
    permission: 'orders'
  },
  {
    name: 'Roterização',
    path: 'router',
    image: localIcon,
    section: 'Aplicações',
    permission: 'router'
  },
  {
    name: 'Fiscal',
    path: 'invoice',
    image: fiscalIcon,
    section: 'Aplicações',
    permission: 'fiscal'
  },
  {
    name: 'Análise de Crédito',
    path: 'analise-credito',
    image: financialIcon,
    section: 'Aplicações',
    permission: 'analise-credito'
  },
  {
    name: 'Empresas',
    path: 'companies',
    image: companiesIcon,
    section: 'Banco de dados',
    permission: 'companies'
  },
  {
    name: 'Pessoas',
    path: 'people',
    image: accessesIcon,
    section: 'Banco de dados',
    permission: 'accesses'
  },
  {
    name: 'Equipamentos',
    path: 'equipment',
    image: truckIcon,
    section: 'Banco de dados',
    permission: 'equipment'
  },
  {
    name: 'Serviços',
    path: 'service',
    image: serviceIcon,
    section: 'Banco de dados',
    permission: 'services'
  },
  {
    name: 'Anexos',
    path: 'attachments',
    image: attachmentsIcon,
    section: 'Banco de dados',
    permission: 'attachments'
  }
]

// Módulos específicos do tenant 2 (Fashion)
export const fashionModules: ModuleConfig[] = [
  {
    name: 'Desenvolvimento de Produto',
    path: 'product-development',
    image: collectionsIcon,
    section: 'Aplicações',
    permission: 'product-development'
  },
  {
    name: 'Vendas',
    path: 'fashion',
    image: hangerIcon,
    section: 'Aplicações',
    permission: 'orders'
  },
  {
    name: 'Produção',
    path: 'production-fashion',
    image: productionIcon,
    section: 'Aplicações',
    permission: 'production',
    dependencies: ['orders']
  },
  {
    name: 'Financeiro',
    path: 'financial/entry',
    image: financialIcon,
    section: 'Aplicações',
    permission: 'financial'
  },
  {
    name: 'Estoque',
    path: 'stock',
    image: boxIcon,
    section: 'Aplicações',
    permission: 'stock'
  },
  {
    name: 'Compras',
    path: 'purchase',
    image: purchaseIcon,
    section: 'Aplicações',
    permission: 'purchase',
  },
  {
    name: 'Roterização',
    path: 'router',
    image: localIcon,
    section: 'Aplicações',
    permission: 'router'
  },
  {
    name: 'Fiscal',
    path: 'invoice',
    image: fiscalIcon,
    section: 'Aplicações',
    permission: 'fiscal'
  },
  {
    name: 'Análise de Crédito',
    path: 'analise-credito',
    image: financialIcon,
    section: 'Aplicações',
    permission: 'analise-credito'
  },
  {
    name: 'Empresas',
    path: 'companies',
    image: companiesIcon,
    section: 'Banco de dados',
    permission: 'companies'
  },
  {
    name: 'Pessoas',
    path: 'people',
    image: accessesIcon,
    section: 'Banco de dados',
    permission: 'accesses'
  },
  {
    name: 'Equipamentos',
    path: 'equipment',
    image: truckIcon,
    section: 'Banco de dados',
    permission: 'equipment'
  },
  {
    name: 'Serviços',
    path: 'service',
    image: serviceIcon,
    section: 'Banco de dados',
    permission: 'services'
  },
  {
    name: 'Anexos',
    path: 'attachments',
    image: attachmentsIcon,
    section: 'Banco de dados',
    permission: 'attachments'
  }
]

const ALIAS_MAP: Record<string, string[]> = {
  stock: ['stock', 'estoque', 'materia_prima', 'insumos', 'resources', 'resource'],
  user: ['user', 'usuarios', 'pessoas', 'profile', 'perfis', 'acessos', 'accesses'],
  profile: ['profile', 'perfis', 'acessos', 'accesses', 'user', 'usuarios', 'pessoas'],
  accesses: ['accesses', 'acessos', 'profile', 'perfis', 'user', 'usuarios', 'pessoas'],
  resources: ['resources', 'resource', 'insumos', 'recursos'],
  attachments: ['attachments', 'anexos', 'arquivos', 'galeria', 'files', 'companies', 'empresas'],
}

// Mapeamento completo de chaves de módulo para todos os possíveis aliases/ids das tabelas e rotas
const MODULE_KEY_ALIASES: Record<string, string[]> = {
  orders: ['orders', 'vendas', 'orcamentos', 'rastreio', 'funil', 'fashion', 'steel'],
  purchase: ['purchase', 'compras', 'demanda', 'pedidos_compra', 'giro_estoque'],
  production: ['production', 'producao', 'ordens_producao', 'movimentacao', 'funil_producao', 'production-fashion'],
  financial: ['financial', 'financeiro', 'lancamentos', 'pagamentos', 'itens', 'conciliacao', 'a_receber', 'a_pagar', 'entre_contas'],
  router: ['router', 'roteirizacao', 'fretes', 'roteiros'],
  fiscal: ['fiscal', 'nota_fiscal', 'cenario_fiscal', 'invoice'],
  products: ['products', 'product-final', 'product-development', 'desenvolvimento', 'desenvolvimento_produto', 'produto_engenheirado'],
  'product-development': ['product-development', 'products', 'product-final', 'desenvolvimento'],
  certificates: ['certificates', 'qualidade', 'certificados', 'parametros', 'rnc'],
  qualidade: ['qualidade', 'certificates', 'certificados', 'parametros', 'rnc'],
  equipment: ['equipment', 'equipamentos', 'maquinas', 'veiculos'],
  services: ['services', 'servicos', 'service'],
  companies: ['companies', 'empresas', 'todas_empresas', 'juridica', 'fisica', 'propria', 'transportadora'],
  accesses: ['accesses', 'profile', 'user', 'perfis_acessos', 'regras', 'pessoas', 'perfis_acesso'],
  stock: ['stock', 'materia_prima', 'estoque', 'insumos', 'resources', 'resource'],
  resources: ['resources', 'resource', 'insumos', 'recursos'],
  'analise-credito': ['analise-credito', 'credito', 'analise_credito'],
  attachments: ['attachments', 'anexos', 'arquivos', 'galeria', 'files', 'companies', 'empresas'],
}

// 🔒 Módulos que exigem concessão explícita (Whitelist)
const RESTRICTED_MODULES = new Set(['stock', 'user', 'profile', 'accesses', 'resources'])

export function hasModulePermission(module: ModuleConfig, userPermissions: string[] = [], isAdmin?: boolean): boolean {
  // Admins (ADMIN_GLOBAL e TENANT_ADMIN) possuem acesso total a todos os módulos
  if (isAdmin) {
    return true
  }

  const rawPermissions = userPermissions || []

  // Se o usuário não tiver NENHUMA permissão configurada, exibe apenas os públicos
  if (rawPermissions.length === 0) {
    return module.permission === 'public'
  }

  const permKey = module.permission
  const aliases = MODULE_KEY_ALIASES[permKey] || ALIAS_MAP[permKey] || [permKey]

  // 1. Se houver algum bloqueio explícito (ex: 'vendas:deny'), esconde o módulo
  const hasDeny = rawPermissions.some((perm) => {
    if (typeof perm !== 'string') return false
    const clean = perm.toLowerCase().trim()
    const cleanKey = clean.split(':')[0]
    const isDeny = perm.endsWith(':deny') || perm.endsWith(':block') || clean.startsWith('deny:') || clean.startsWith('block:')
    return isDeny && (aliases.includes(cleanKey) || aliases.includes(clean) || cleanKey === permKey)
  })

  if (hasDeny) {
    return false
  }

  // 2. Se for 'public' e não estiver negado, libera
  if (module.permission === 'public') {
    return true
  }

  // 3. Para módulos com chave de permissão: exibe apenas se o usuário tiver uma permissão concedida correspondente
  return rawPermissions.some((perm) => {
    if (typeof perm !== 'string') return false
    const clean = perm.toLowerCase().trim()
    const cleanKey = clean.split(':')[0]

    return (
      (aliases.includes(cleanKey) || aliases.includes(clean) || cleanKey === permKey) &&
      !perm.endsWith(':deny') &&
      !perm.endsWith(':block') &&
      !perm.startsWith('deny:') &&
      !perm.startsWith('block:')
    )
  })
}

export function getModulesForTenant(tenantId: number | null): ModuleConfig[] {
  if (tenantId === null) return []

  if (tenantId === 2) {
    return fashionModules
  }

  return industrialModules
}

export function getModulesForTenantWithPermissions(tenantId: number | null, userPermissions: string[] = [], isAdmin?: boolean): ModuleConfig[] {
  if (tenantId === null) return []
  const allModules = getModulesForTenant(tenantId)
  if (isAdmin) {
    return allModules
  }
  return allModules.filter((module) => hasModulePermission(module, userPermissions, isAdmin))
}

export function getModulesBySection(tenantId: number | null, isGlobalAdmin?: boolean) {
  if (tenantId === null) return {} as Record<string, ModuleConfig[]>
  const modules = getModulesForTenant(tenantId)
  const sections = modules.reduce((acc, module) => {
    if (!acc[module.section]) {
      acc[module.section] = []
    }
    acc[module.section].push(module)
    return acc
  }, {} as Record<string, ModuleConfig[]>)
  const orderedSections: Record<string, ModuleConfig[]> = {}
  if (sections['Aplicações']) {
    orderedSections['Aplicações'] = sections['Aplicações']
  }
  if (sections['Banco de dados']) {
    orderedSections['Banco de dados'] = sections['Banco de dados']
  }
  if (isGlobalAdmin) {
    orderedSections['Governança'] = [
      {
        name: 'Auditoria',
        path: 'audit',
        image: clipboardIcon,
        section: 'Governança',
        permission: 'public',
      },
    ]
  }
  return orderedSections
}

export function getModulesBySectionWithPermissions(
  tenantId: number | null,
  userPermissions: string[] = [],
  isAdmin?: boolean,
  isGlobalAdmin?: boolean
) {
  if (tenantId === null) return {} as Record<string, ModuleConfig[]>

  const modules = getModulesForTenantWithPermissions(tenantId, userPermissions, isAdmin)

  const sections = modules.reduce((acc, module) => {
    if (!acc[module.section]) {
      acc[module.section] = []
    }
    acc[module.section].push(module)
    return acc
  }, {} as Record<string, ModuleConfig[]>)

  const orderedSections: Record<string, ModuleConfig[]> = {}

  if (sections['Aplicações']) {
    orderedSections['Aplicações'] = sections['Aplicações']
  }

  if (sections['Banco de dados']) {
    orderedSections['Banco de dados'] = sections['Banco de dados']
  }

  if (isGlobalAdmin) {
    orderedSections['Governança'] = [
      {
        name: 'Auditoria',
        path: 'audit',
        image: clipboardIcon,
        section: 'Governança',
        permission: 'public',
      },
    ]
  }

  return orderedSections
}

export function canEditStock(userPermissions: string[] = []): boolean {
  return hasPermission(userPermissions, 'stock:update') || hasPermission(userPermissions, 'stock:adjust') || hasPermission(userPermissions, 'edit-stock') || hasPermission(userPermissions, 'stock')
}
